import { Stack } from '@chakra-ui/react';
import React from 'react';
import ProcessedEmails from '../features/processed-emails/ProcessedEmails';

const ProcessedEmailsPage = () => {

    return (
        <Stack gap={5}>
            <ProcessedEmails />
        </Stack>
    )
}

export default ProcessedEmailsPage;